import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {
    Breadcrumb,
    Menu,
    Segment,
    Card,
    Header,
    Icon,
    Image,
    Button,
    Message
} from 'semantic-ui-react';

import TableData from "../../data/TableData";

import CustomDivider from '../../components/extras/CustomDivider';
import BranchOfficeData from "../../data/BranchOfficeData";
import TableDialog from "../../components/my_bisttro/TableDialog";
import Loading from "../../components/extras/Loading";
import {showToast} from "../../actions/ToastAction";
import {connect} from "react-redux";
import CheckPermission from "../../components/extras/CheckPermission";

const tableIcon = require('../../img/icons/table.svg');
const tableAddIcon = require('../../img/icons/table_add.svg');

class Tables extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            currentBranch: {},
            currentSection: null,
            sections: [],
            tables: [],
            indexBranch: 0,
            indexSection: 0,
            loading: true,
            sending_new:false
        };
        this.addTable = this.addTable.bind(this);
        this.deleteTable = this.deleteTable.bind(this);
        this.updateTable = this.updateTable.bind(this);
    }

    componentDidMount() {
        this.initialFetch();
    }

    initialFetch() {
        BranchOfficeData.adminTables().then(data =>{
            if(!data.hasOwnProperty('detail')){
                this.setState({data, currentBranch: data[0], loading:false});
                this.handleBranchItemClick(data[0], 0);
            }
        });
    };

    handleBranchItemClick = (branch, index) => {
        this.setState({currentBranch: branch, indexBranch: index, tables: [], currentSection: null});
        if (branch.section.length > 0) {
            this.menuSections(branch.section);
            this.handleSectionItemClick(branch.section[0], 0);
        }
    };

    handleSectionItemClick = (section, index) => {
        this.makeTables(section.table);
        this.setState({currentSection: section, indexSection: index});
    };

    menuSections = (data) => {
        let sections = data.map(function (section, i) {
            return (<Menu.Item name={section.name} onClick={() => this.handleSectionItemClick(section, i)}
                               key={section.id}/>)
        }, this);
        this.setState({sections});
    };

    updateTable = (table, index) => {
        this.refs.dialog.handleOpen(table, index);
    };

    updateData = (res, index) => {
        let data = this.state.data;
        data[this.state.indexBranch].section[this.state.indexSection].table[index] = res;
        this.setState(data);
        this.makeTables(this.state.currentSection.table);
    };

    deleteTable = (id, index) => {
        TableData.delete(id, (res) => {
            if (res === null) {
                let data = this.state.data;
                data[this.state.indexBranch].section[this.state.indexSection].table.splice(index, 1);
                this.setState(data);
                this.makeTables(this.state.currentSection.table);
            } else {
                this.props.showToast({message:'Tenemos un problema, inténtalo más tarde!', type:'error'});
            }
            this.setState({open: false});
        });
    };

    makeTables = (data) => {
        let tables = data.map(function (table, index) {
            return (
                <Card key={table.id}>
                    <Card.Content>
                        <Header as='h5' icon>
                            <Icon><Image src={tableIcon} alt='logo' width={38}/></Icon>
                            {table.number}
                        </Header>
                        {table.is_busy ?
                            <Button color='green' size='mini' fluid>Ocupada</Button> :
                            <Button.Group fluid size='mini'>
                                <Button icon='trash' onClick={() => this.deleteTable(table.id, index)} />
                                <Button icon='edit' onClick={() => this.updateTable(table, index)}/>
                            </Button.Group>}
                    </Card.Content>
                </Card>
            )
        }, this);
        this.setState({tables});
    };

    addTable = () => {
        this.setState({sending_new:true});
        TableData.add({id: this.state.currentSection.id}, (res) => {
            if (res !== null && res.hasOwnProperty('id')) {
                let data = this.state.data;
                data[this.state.indexBranch].section[this.state.indexSection].table.push(res);
                this.setState(data);
                this.makeTables(this.state.currentSection.table);
            } else {
                this.props.showToast({message:'Tenemos un problema, inténtalo más tarde!', type:'error'});
            }
            this.setState({open: false, sending_new:false});
        });
    };

    render() {
        let menuBranchs = this.state.data.map(function (branch, index) {
            return (<Menu.Item name={branch.name} onClick={() => this.handleBranchItemClick(branch, index)}
                               active={this.state.currentBranch.id === branch.id} key={branch.id}/>)
        }, this);

        return (
            <div>
                <Helmet>
                    <title>Administración de Mesas | Configuraciones - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Mesas</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Menu attached='top' tabular>
                    {menuBranchs}
                </Menu>
                {this.state.loading ? <Loading/>:<Segment attached='bottom'>
                    {this.state.currentSection ?
                        <div>
                            <Menu>
                                {this.state.sections}
                            </Menu>
                            <Header as='h2'>{this.state.currentSection.name}</Header>
                            <Card.Group itemsPerRow={5} stackable>
                                <Card key={0} color='orange'>
                                    <Card.Content>
                                        <Header as='h5' icon>
                                            <Icon><Image src={tableAddIcon} alt='logo' width={38}/></Icon>
                                            Mesa
                                        </Header>
                                        <Button icon='add' fluid primary size='mini' content="Nueva"
                                                onClick={this.addTable} disabled={this.state.sending_new} loading={this.state.sending_new}/>
                                    </Card.Content>
                                </Card>
                                {this.state.tables}
                            </Card.Group>
                        </div> : <Message icon='bell' header='No hay secciones registradas'/>
                    }
                </Segment>}
                <TableDialog ref="dialog" callbackUpdateData={this.updateData}/>
                <CheckPermission access='settings__tables'/>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showToast(toast){
            dispatch(showToast(toast))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(Tables)



// WEBPACK FOOTER //
// ./src/containers/settings/Tables.js